// removed by extract-text-webpack-plugin
module.exports = {"grid":"grid__25TAq","gridColumns":"gridColumns__1X1gj","gridCollapse":"gridCollapse__3HLv9","gridColumn":"gridColumn__36S5z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/GridGuides/styles.scss
// module id = 266
// module chunks = 0